var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"user":_vm.user}}),_vm._v(" "),_c('main',{staticClass:"pt-16"},[_vm._t("default")],2),_vm._v(" "),_c('BottomBar',{attrs:{"diamonds":_vm.user.gems}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }